import {createEntityService} from 'utils/createEntityService';
import {ClientVisit} from 'types/clientVisit';

export const clientVisitService = createEntityService<ClientVisit>({
  baseUrl: 'api/v1/client_visits',
  entityName: 'clientVisit',
});